var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"mt-16","padless":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"py-4 text-center",staticStyle:{"color":"#ff3e00"},attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Drinksy")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }